<template>
  <div id="booking" :class="{ hidden: hideInfo }">
    <div class="booking-text z2">
      <p class="ml3">
        <a href="#" @click="hideInfo = !hideInfo">
          <span v-if="hideInfo">Show Information</span>
          <span v-else>Hide Text</span>
        </a>
      </p>
      <div v-html="booking.Content" class="pl3 text"></div>
    </div>
    <div class="booking-text-bg z1"></div>
    <div class="booking-images">
      <img v-for="image in images" :src="image.thumbnails.full.url" :key="image.id" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {

  name: 'Booking',

  data () {
    return {
      hideInfo: false
    }
  },

  computed: {
    ...mapState(['booking']),
    images () {
      let images = this.booking.Images
      return images.reverse()
    }
  },

  methods: {
    ...mapActions(['loadBooking'])
  },

  mounted () {
    this.loadBooking()
  }
}
</script>

<style lang="css" scoped>
  #booking {
    .booking-text-bg {
      transition: all 0.5s ease-out;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.6);
      pointer-events: none;
    }

    .booking-text {
      width: 500px;
      max-width: 90%;
      position: fixed;
      top: 0;
      left: 0;
      font-size: 18px;
      line-height: 24px;
      transition: all 0.5s ease-out;

      p {
        padding: 0;
      }

      &>>>a {
        border-bottom: 1px solid red;
        display: inline-block;

        &:hover {
          text-decoration: none;
        }
      }
    }

    &.hidden {
      .booking-text-bg {
        opacity: 0;
      }

      div.text {
        overflow: hidden;
        height: 0;
      }
    }

    img {
      width: 100%;
      padding: 0;
      margin: 0;
      display: block;
    }
  }
</style>
